import Season from './Season'
import Competition from './Competition'
import RoundType from './RoundType'
import GameStatus from './GameStatus'
import GroupType from './GroupType'
import Gender from './Gender'
import Discipline from './Discipline'
import Sport from './Sport'

export default class Game {
  constructor (data) {
    this.id = data.id

    this.dayId = data.dayId
    this.statusId = data.statusId
    this.stadiumId = data.stadiumId
    this.weatherId = data.weatherId
    this.groupTypeId = data.groupTypeId
    this.roundTypeId = data.roundTypeId
    this.competitionId = data.competitionId
    this.seasonId = data.seasonId
    this.genderId = data.genderId
    this.disciplineId = data.disciplineId
    this.eventId = data.eventId
    this.eventUnitId = data.eventUnitId
    this.sportId = data.sportId

    this.order = data.order
    this.day = data.day
    this.audience = data.audience
    this.temperature = data.temperature

    this.date = data.date
    this.dateUpdated = data.updated

    this.season = data.season ? new Season(data.season) : null
    this.competition = data.competition ? new Competition(data.competition) : null
    this.roundType = data.roundType ? new RoundType(data.roundType) : null
    this.groupType = data.groupType ? new GroupType(data.groupType) : null
    this.sport = data.sport ? new Sport(data.sport) : null
    this.discipline = data.discipline ? new Discipline(data.discipline) : null
    this.gender = data.gender ? new Gender(data.gender) : null
    this.status = data.status ? new GameStatus(data.status) : null

    this.search = false
    this.searching = false

    this.searchNotification = null
  }
}
